export const getUserFullName = ({firstName, lastName}:{firstName: string | null | undefined, lastName: string | null | undefined}) => {
  return (
    firstName && lastName ? `${lastName} ${firstName}` :
      firstName ? `${firstName}` :
        lastName ? `${lastName}` : ''
  )
};
